import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import URL from 'url-parse';

import { select } from '@swf/core/store';
import { absoluteURL } from '@swf/core/utils';

export interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  openLinkInNewTab?: boolean;
}

const embeddedURLPrefix = 'external-';

const CrossPlatformLink: React.FC<Props> = ({
  href,
  openLinkInNewTab,
  className,
  children,
  ...props
}) => {
  const origin = useSelector(select.location.getOrigin);
  const localePrefix = useSelector(select.location.getLocaleURL);
  const isEmbedded = useSelector(select.site.isEmbedded);
  const isAbsoluteURL = absoluteURL(href);
  const embeddedHref = new URL(
    isAbsoluteURL
      ? `${embeddedURLPrefix}${href}`
      : `${embeddedURLPrefix}${origin}${localePrefix}${href}`,
    true
  ).toString();

  return isAbsoluteURL || isEmbedded ? (
    <a
      className={className}
      href={isEmbedded ? embeddedHref : href}
      rel="noopener noreferrer"
      target={isEmbedded || openLinkInNewTab ? '_blank' : undefined}
      {...props}
    >
      {children}
    </a>
  ) : (
    <Link
      to={href}
      className={className}
      rel="noopener noreferrer"
      target={openLinkInNewTab ? '_blank' : undefined}
      {...props}
    >
      {children}
    </Link>
  );
};

export default CrossPlatformLink;
